import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import map from 'lodash/map';
import { useSelector } from 'react-redux';
import Project from '../../../../common/selectors/Project';
import digestLogsDefaultFilters from './digestLogsDefaultFilters';
import FiltersToolbar from '../FiltersToolbar';
import { setTimezone } from '../../../../utils/useProjectFilters';

const noOptionsSubscription = () => null;

/**
 * Filters toolbar for Digest logs — same UX as Triggered alerts.
 */
const DigestLogsConnectedFilters = ({ storeKey, dashboardId, projectId }) => {
  const timezone = useSelector(
    Project.one().whereIdEquals(projectId).toTimezone(),
  );

  const presets = useMemo(
    () =>
      map(digestLogsDefaultFilters, (preset) => setTimezone(preset, timezone)),
    [timezone],
  );

  return (
    <FiltersToolbar
      storeKey={storeKey}
      dashboardId={dashboardId}
      presets={presets}
      optionsSubscription={noOptionsSubscription}
    />
  );
};

DigestLogsConnectedFilters.propTypes = {
  storeKey: PropTypes.string.isRequired,
  dashboardId: PropTypes.string,
  projectId: PropTypes.string.isRequired,
};

DigestLogsConnectedFilters.defaultProps = {
  dashboardId: null,
};

export default DigestLogsConnectedFilters;
